import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DadosProvider {

  private logado = false;

  cliente = {email:"", nome:"", senha:""};

  endereco:any;

  configuracao:any;

  firebaseToken = "";

  faleNutri = false;

  permitirDuvida:boolean = false;
  
  constructor(private storage: Storage) {
  }

  salvarCliente(cliente, salvarSenha = false){
    this.setLogado(true);

    this.cliente = {nome:cliente.nome, email:cliente.email, senha:""};
    
    if(salvarSenha){
      this.cliente.senha = cliente.senha;
    }

    this.storage.set('cliente', this.cliente);
  }

  carregarCliente():Observable<any>{
    return Observable.create(
      (obs) => {
        this.storage.get('cliente').then(
          (cliente) => {
            if(cliente)
              this.cliente = cliente;
            obs.next(cliente);
            obs.complete();
          }
        ).catch(
          (erro) => {
            obs.next(null);
            obs.complete();
          }
        );
      }
    );
  }

  salvarEndereco(endereco){
    this.endereco = endereco;
  }

  salvarConfiguracao(configuracao){
    this.configuracao = configuracao;
  }

  getTaxaEntrega():{id:number, valor:number}{
    if(this.endereco && this.endereco.taxaentrega_id){
      return {id:this.endereco.taxaentrega_id, valor:this.endereco.valorTaxaEntrega };
    }else if(this.configuracao && this.configuracao.taxapadrao_id){
      return {id:this.configuracao.taxapadrao_id, valor:this.configuracao.valoTaxaPadrao };
    }

    return  {id:0, valor:0.00 };
  }

  getValorMinimoPedidoEntrega(){
    if(this.configuracao && this.configuracao.valorMinimoTaxa){
      return this.configuracao.valorMinimoTaxa;
    }

    return 0;
  }

  get(key:string) : Observable<any>{
    return Observable.create(
      (obs) => {
        this.storage.get(key).then((val) => {
          obs.next(val);
          obs.complete();
        });
      }
    );
  }

  set(key:string, value:any){
    this.storage.set(key, value);
  }
  
  remove(key:string){
    this.storage.remove(key);
  }

  limparSenha(){
    this.cliente = {nome:this.cliente.nome, email:this.cliente.email, senha:null};
    
    this.storage.set('cliente', this.cliente);
  }

  setLogado(logado){
    this.logado = logado;
  }

  getLogado(){
    return this.logado;
  }
  
  carregarMenagens():Observable<any>{
    return Observable.create(
      (obs) => {
        this.storage.get('mensagens').then(
          (dados) => {
            obs.next(dados);
            obs.complete();
          }
        ).catch(
          (erro) => {
            obs.next([]);
            obs.complete();
          }
        );
      }
    );
  }
} 



// WEBPACK FOOTER //
// ./src/providers/dados/dados.ts